import type { Question } from './types';

export const questions: Question[] = [
  {
    id: 'objective',
    question: 'Qual é o principal objetivo do seu conteúdo?',
    placeholder: 'Ex: Educar, entreter, vender produtos...'
  },
  {
    id: 'contentType',
    question: 'Qual tipo de conteúdo você costuma postar no seu canal?',
    placeholder: 'Ex: Tutoriais, vlogs, reviews...'
  },
  {
    id: 'bestPerforming',
    question: 'Qual tipo de post recebeu mais curtidas e visualizações até agora?',
    placeholder: 'Ex: Vídeos explicativos, posts com dicas...'
  },
  {
    id: 'targetAudience',
    question: 'Quem é o público-alvo do seu canal?',
    placeholder: 'Ex: Jovens interessados em tecnologia...'
  }
];